var _componentSelect2 = function($context) {
    if (!$().select2) {
        console.warn('Warning - select2.min.js is not loaded.');
        return;
    }
    
    $.fn.select2.defaults.set("placeholder", "- Wählen -");
    
    $context = $context instanceof jQuery ? $context : $(document);
    
    $context.find('.js-select').select2({
        minimumResultsForSearch: Infinity
    });
    
    // icube - z obrazkiem
    function imageFormat(i) {
        var originalOption = i.element;
        if (!i.id) { return i.text; }
        var $image = '<span><img src="' + $(i.element).data('image') + '" style="max-width: 40px; max-height: 40px;" /> ' + i.text + '</span>';

        return $image;
    }

    $context.find('.js-ci-select-with-img').select2({
        templateResult: imageFormat,
        templateSelection: imageFormat,
        minimumResultsForSearch: Infinity,
        escapeMarkup: function(m) { return m; }
    });
    
    $context.find('.js-ci-select-with-search').select2();    
};

function init($context) {
    _componentSelect2($context);
}


export const Select2Selects = {
    init
}
